import styles from './AuroraField.module.css';

/**
 * The soft colour field behind every brand surface on web — the port of
 * `apps/mobile/src/onboarding/AuroraField.tsx`.
 *
 * The phone builds it from SVG radial gradients on one shared Reanimated
 * clock; this is CSS, because the whole thing is decorative and a browser
 * composites gradients and a blur without any of that machinery. What did NOT
 * carry over unchanged are the opacities — see the stylesheet's header.
 *
 * ## Why this is four elements and not two pseudo-elements
 *
 * It WAS `.field::before` / `.field::after`, each carrying both the gradients
 * and `filter: blur(70px)`, and each animated. That made the page drop about a
 * third of its frames — the owner reported the cursor and the inputs lagging,
 * and it measured at 333-566ms per frame against 16.7ms for the same field
 * with the blur removed.
 *
 * A filtered element that is ALSO animated has to be re-blurred on every
 * frame. Split in two, it does not: the wrapper carries the animation and
 * nothing else, the child carries the gradients and the blur and never moves,
 * so the blur is rasterised once and the browser only composites a transform
 * after that. Same picture — measured at a mean difference of 0.49/255, with
 * no pixel off by more than 3 — for a twentieth of the work.
 *
 * The pair is what matters, not the tag names. Putting the blur back onto the
 * animated node, in any form, brings the jank straight back.
 *
 * `aria-hidden`: it says nothing, and the copy in front of it is real text.
 */
export function AuroraField() {
  return (
    <div className={styles.field} aria-hidden="true">
      <div className={styles.warmDrift}>
        <div className={styles.warm} />
      </div>
      <div className={styles.deepDrift}>
        <div className={styles.deep} />
      </div>
    </div>
  );
}
